import axios from 'axios';
import {
  CongresoPublico,
  CongresoEdicionHistorica,
  AgendaSesion,
  ExpositorPublico,
  SponsorPublico,
  CongresoFaq,
  CongresoSeccionAlojamientoPublico,
  PadronSorteoPaginado
} from '../types/congreso.types';

const API_BASE = '/api/congreso-publico';

export const congresoPublicoApi = {
  getCongresoActivo: async (): Promise<CongresoPublico> => {
    const { data } = await axios.get<CongresoPublico>(`${API_BASE}/activo`);
    return data;
  },

  getCongresoPorId: async (idCongreso: number): Promise<CongresoPublico> => {
    const { data } = await axios.get<CongresoPublico>(`${API_BASE}/${idCongreso}`);
    return data;
  },

  getEdicionesHistoricas: async (): Promise<CongresoEdicionHistorica[]> => {
    const { data } = await axios.get<CongresoEdicionHistorica[]>(`${API_BASE}/ediciones`);
    return data;
  },

  getAgenda: async (idCongreso: number): Promise<AgendaSesion[]> => {
    const { data } = await axios.get<AgendaSesion[]>(`${API_BASE}/${idCongreso}/agenda`);
    return data;
  },

  getExpositores: async (idCongreso: number): Promise<ExpositorPublico[]> => {
    const { data } = await axios.get<ExpositorPublico[]>(`${API_BASE}/${idCongreso}/expositores`);
    return data;
  },

  getSponsors: async (idCongreso: number): Promise<SponsorPublico[]> => {
    const { data } = await axios.get<SponsorPublico[]>(`${API_BASE}/${idCongreso}/sponsors`);
    return data;
  },

  getFaqs: async (idCongreso: number): Promise<CongresoFaq[]> => {
    const { data } = await axios.get<CongresoFaq[]>(`${API_BASE}/${idCongreso}/faqs`);
    return data;
  },

  getAlojamientos: async (idCongreso: number): Promise<CongresoSeccionAlojamientoPublico> => {
    const { data } = await axios.get<CongresoSeccionAlojamientoPublico>(`${API_BASE}/${idCongreso}/alojamientos`);
    return data;
  },

  getPadronSorteo: async (
    idCongreso: number,
    query?: string,
    idColegio?: number,
    page: number = 1,
    pageSize: number = 20
  ): Promise<PadronSorteoPaginado> => {
    const params = new URLSearchParams();
    if (query && query.trim()) params.append('q', query.trim());
    if (idColegio && idColegio > 0) params.append('idColegio', idColegio.toString());
    params.append('page', page.toString());
    params.append('pageSize', pageSize.toString());

    const { data } = await axios.get<PadronSorteoPaginado>(
      `${API_BASE}/${idCongreso}/sorteo/padron?${params.toString()}`
    );
    return data;
  }
};
